import { render, staticRenderFns } from "./DecorationMethods.vue?vue&type=template&id=97b1077c"
import script from "./DecorationMethods.vue?vue&type=script&lang=js"
export * from "./DecorationMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports